import { render, staticRenderFns } from "./hqStuHealthActivitiesEdit.vue?vue&type=template&id=eb04152a&scoped=true"
import script from "./hqStuHealthActivitiesEdit.vue?vue&type=script&lang=js"
export * from "./hqStuHealthActivitiesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb04152a",
  null
  
)

export default component.exports